import { gql } from 'apollo-boost';


export const fragments = {

    ASSUMPTIONS: {
        QUERY_RETURN: `
			assumptions {
				answerValue
				createdById
				updatedById
				intakeQuestion{
					id
					ordinal
					category{ id name }
					questionContext
					conditions {
						targetIntakeQuestionId
					}
					requiredInDiscovery
				}
				updatedUtc
			}
			unansweredQuestions {
				description
				intakeQuestion{
					id
					ordinal
					category{ id name }
					questionContext
					requiredInDiscovery
				}
				triggeringCondition {
					value
					conditionType
					targetIntakeQuestion{
						id
						ordinal
						category{ id name }
						questionContext
						requiredInDiscovery
					}
				}
			}
		`,

        MUTATION_RETURN: `
			answerValue
			intakeQuestionId
			intakeQuestion { name inputType dataValueSetId }
			projectId
		`,

        VALUE_FIELDS: `
			assumptions {
				answerValue
				createdById
				createdUtc
				updatedById
				updatedUtc
				intakeQuestion{
					id
					ordinal
					category{ id displayName description }
					name
					description
					inputType
					questionContext
					questionText
					requiredInDiscovery
				}
			}
		`
    },

    ASSUMPTION_GROUPS: {

        QUERY_RETURN: `id name displayName ordinal`,

        MUTATION_RETURN: `id name displayName ordinal`,

        EDIT_FIELDS: `
			id
			name
			displayName
			description
			ordinal
			assumptionGroupIntakeQuestions{
				intakeQuestionId
				ordinal
			}
		`,
    },

    STRATEGIC_ASSUMPTIONS_TEMPLATE: {

        QUERY_RETURN: `id templateString`,

        MUTATION_RETURN: `id templateString`,
    }
};

export const queries = {

    GET_PROJECT_ASSUMPTIONS: ( returnQueryString = fragments.ASSUMPTIONS.QUERY_RETURN ) => gql`
        query GetProjectAssumptions( $input: ProjectAssumptionsQueryInput! ){
            projectAssumptions( input: $input )  {
                ${ returnQueryString }
            }
        }`,

    GET_ASSUMPTION_GROUPS: ( returnQueryString = fragments.ASSUMPTION_GROUPS.QUERY_RETURN ) => gql`
        query GetAssumptionGroups( $order: [AssumptionGroupSortInput!], $where: AssumptionGroupFilterInput ){
            assumptionGroups( order: $order, where: $where) {
                ${ returnQueryString }
            }
        }`,

    GET_ASSUMPTION_GROUP: ( returnQueryString = fragments.ASSUMPTION_GROUPS.QUERY_RETURN ) => gql`
        query GetAssumptionGroup( $id: Uuid! ){
            assumptionGroups( where: { id: { eq: $id } } ) {
                ${ returnQueryString }
            }
        }`,

    GET_STRATEGIC_ASSUMPTION_TEMPLATE: ( returnQueryString = fragments.STRATEGIC_ASSUMPTIONS_TEMPLATE.QUERY_RETURN ) => gql`
        query GetStrategicAssumptionTemplate {
            strategicAssumptionTemplate {
                ${ returnQueryString }
            }
        }`,
};

export const mutations = {

    SAVE_ASSUMPTION: ( returnQueryString = fragments.ASSUMPTIONS.MUTATION_RETURN ) => gql`
        mutation SaveProjectAssumption( $input: AssumptionSaveCommandInput! ){
            saveAssumption( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    UPDATE_ASSUMPTION_GROUP_ORDER: ( returnQueryString = fragments.ASSUMPTION_GROUPS.QUERY_RETURN ) => gql`
        mutation updateAssumptionGroupOrder( $input: AssumptionGroupUpdateOrdinalsCommandInput! ){
            updateAssumptionGroupOrdinals( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    CREATE_ASSUMPTION_GROUP: ( returnQueryString = fragments.ASSUMPTION_GROUPS.MUTATION_RETURN ) => gql`
        mutation CreateAssumptionGroup( $input: AssumptionGroupCreateCommandInput! ){
            createAssumptionGroup( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    UPDATE_ASSUMPTION_GROUP: ( returnQueryString = fragments.ASSUMPTION_GROUPS.MUTATION_RETURN ) => gql`
        mutation UpdateAssumptionGroup( $input: AssumptionGroupUpdateCommandInput! ){
            updateAssumptionGroup( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    DELETE_ASSUMPTION_GROUP: () => gql`
        mutation DeleteAssumptionGroup( $input: AssumptionGroupDeleteCommandInput! ){
            deleteAssumptionGroup( input: $input )
        }`,

    UPDATE_STRATEGIC_ASSUMPTION_TEMPLATE: ( returnQueryString = fragments.STRATEGIC_ASSUMPTIONS_TEMPLATE.MUTATION_RETURN ) => gql`
        mutation UpdateStrategicAssumptionTemplate( $input: StrategicAssumptionTemplateUpdateCommandInput! ){
            updateStrategicAssumptionTemplate( input: $input ) {
                ${ returnQueryString }
            }
        }`,
};

export const functions = {}

export const AssumptionQueries = {
    fragments,
    queries,
    mutations,
    functions,
};
